import { gql } from "@apollo/client";

export const GET_LISTAR_MINUTA_ESTADOS = gql`
    query GetEstadoMinuta {
        estadoMinuta {
            idEstadoMinutaSap,
            codigo,
            descripcion
        }
    }
`;

export const adaptListarMinutaEstados = (estado) => {
  return {
    idEstadoMinuta: estado?.idEstadoMinutaSap,
    codigo: estado?.codigo,
    descripcion: estado?.descripcion
  };
};

export const adaptListarMinutaEstadosArray = (estados) => {
  return structuredClone(estados)?.
  map((estado) => adaptListarMinutaEstados(estado));
};